const VERSION = { APP: 10, CODE: 10, NAME: "0.20", API: 2 };

export { VERSION };
